import React, { Component } from 'react';
import { Helmet } from 'react-helmet-async';
import makeCancellablePromise from 'make-cancellable-promise';
import { toast } from 'react-toastify';
import { setDefaultOptions, format, startOfMonth, endOfMonth, startOfDay, differenceInDays } from 'date-fns';
import Select from 'react-select';
import axios from 'axios';
import { RiCalendarEventFill, RiCalendarTodoFill, RiCheckboxCircleFill, RiCloseCircleFill, RiEyeFill, RiEyeOffFill, RiCreativeCommonsLine, RiCreativeCommonsByLine, RiCreativeCommonsNcLine, RiCreativeCommonsSaLine } from 'react-icons/ri';
import { StickyContainer, Sticky } from 'react-sticky';
import { enUS } from 'date-fns/locale';

import { ReactComponent as Logo } from './../assets/img/logo.svg';

class App extends Component{
  constructor(){
    super();
    
    this.state = {
      pageLoad: true,
      responseApi: '',
      calendar: [],
      totalDays: 0,
      totalWeekend: 0,
      totalPublic: 0,
      totalHoliday: 0,
      totalLong: 0,
      high: 0,
      yearList: [],
      year: '',
      month: '',
      monthActive: '',
      monthDiff: false,
      joint: true,
      saturday: true,
      longWeekend: true,
      inline: false,
      dayOpen: '',
      nextYear: false,
      device: '',
      isMobile: false,
      isTablet: false,
      isLandscape: true
    }

    this.cancellableLoad = '';

    this.copy = 2024;
    this.today = startOfDay(new Date());
    this.myRef = React.createRef();
    this.day = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    this.month = [{
      label: 'January', value: 1
    }, {
      label: 'February', value: 2
    }, {
      label: 'March', value: 3
    }, {
      label: 'April', value: 4
    }, {
      label: 'May', value: 5
    }, {
      label: 'June', value: 6
    }, {
      label: 'July', value: 7
    }, {
      label: 'August', value: 8
    }, {
      label: 'September', value: 9
    }, {
      label: 'October', value: 10
    }, {
      label: 'November', value: 11
    }, {
      label: 'December', value: 12
    }];
    this.semester = [0, 0];
    this.quarter = [0, 0, 0, 0];
    
    this.switchJoint = this.switchJoint.bind(this);
    this.switchSaturday = this.switchSaturday.bind(this);
    this.switchLongWeekend = this.switchLongWeekend.bind(this);
    this.switchInline = this.switchInline.bind(this);
    this.selectChange = this.selectChange.bind(this);
    this.monthChange = this.monthChange.bind(this);
    this.callCalendar = this.callCalendar.bind(this);
    this.generateCalendar = this.generateCalendar.bind(this);
    this.toggleDay = this.toggleDay.bind(this);
    this.goToday = this.goToday.bind(this);
    this.scrollToday = this.scrollToday.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  componentDidMount(){
    setDefaultOptions({ locale: enUS });

    let listYear = [];

    for(let i = 2; i > 0; i--){
      const newYear = this.today.getFullYear() - i;

      listYear.push({
        label: newYear,
        value: newYear
      });
    }

    for(let i = 0; i < 3; i++){
      const newYear = this.today.getFullYear() + i;

      listYear.push({
        label: newYear,
        value: newYear
      });
    }

    // listYear.push({
    //   label: this.today.getFullYear(),
    //   value: this.today.getFullYear()
    // });

    const selMonth = this.month.find(x => x.value === (this.today.getMonth() + 1)),
          selYear = listYear.find(x => x.value === this.today.getFullYear());
    
    this.setState({
      yearList: listYear,
      month: selMonth,
      monthActive: selMonth,
      year: selYear
    });

    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  }

  componentDidUpdate(prevProps, prevState){
    if(
      this.state.year !== prevState.year
    ){
      this.callCalendar();
    }
    
    if(
      this.state.joint !== prevState.joint ||
      this.state.saturday !== prevState.saturday ||
      this.state.longWeekend !== prevState.longWeekend
    ){
      this.generateCalendar(this.state.responseApi);
    }

    if(this.state.pageLoad !== prevState.pageLoad){
      if(!this.state.pageLoad){
        this.scrollToday();
      }
    }

    if(this.state.month !== prevState.month){
      if(!this.state.pageLoad){
        if(this.state.monthDiff){
          this.setState({ monthDiff: false });
        }else{
          let topPad = 0;

          if(this.state.isMobile){
            if(this.state.isLandscape){
              topPad = 118;
            }else{
              topPad = 218;
            }
          }else if(this.state.isTablet){
            topPad = 118;
          }else{
            topPad = 58;
          }

          window.scrollTo({ top: document.getElementById(this.state.month.label).offsetTop - topPad, behavior: 'smooth' });
        }
      }
    }

    if(this.state.monthActive !== prevState.monthActive){
      if(!this.state.pageLoad && this.state.monthActive.value !== this.state.month.value){
        this.setState({ month: this.state.monthActive });
      }
    }

    // console.log(this.state.month, this.state.monthActive, this.state.monthDiff);
  }

  componentWillUnmount(){
    window.removeEventListener('resize', this.handleResize);

    if(this.cancellableLoad){
      this.cancellableLoad.cancel();
    }
  }

  switchJoint(){
    this.setState({ joint: !this.state.joint });
  }

  switchSaturday(){
    this.setState({ saturday: !this.state.saturday });
  }

  switchLongWeekend(){
    this.setState({ longWeekend: !this.state.longWeekend });
  }

  switchInline(){
    this.setState({ inline: !this.state.inline });
  }

  selectChange(value, event){
    this.setState({ [event.name]: value });
  }

  monthChange(value){
    const findMonth = this.month.find(x => x.label === value);

    this.setState({ monthActive: findMonth });

    if(this.state.month.value !== findMonth.value){
      this.setState({ monthDiff: true });
    }
  }

  callCalendar(){
    this.setState({ pageLoad: true });

    let nextYear = false;

    if(this.state.year.value <= this.today.getFullYear()){
      this.cancellableLoad = makeCancellablePromise(
        axios.get('https://dayoffapi.vercel.app/api?year=' + this.state.year.value)
      );
    }else{
      nextYear = true;
      
      this.cancellableLoad = makeCancellablePromise(
        axios.get('https://api-harilibur.vercel.app/api?year=' + this.state.year.value)
      );
    }

    this.setState({ nextYear: nextYear });

    this.cancellableLoad.promise.then((resultApi) => {
      this.generateCalendar(resultApi);

      this.setState({ responseApi: resultApi });
    }).catch((error) => {
      console.error(error);

      toast.error(() => (<>{error.code}<span>{error.message}</span></>));

      this.setState({ pageLoad: false });
    });
  }

  generateCalendar(resultApi){
    let listMonth = [],
        countYear = 1,
        countSemester = 1,
        countQuarter = 1,
        calHigh = 0,
        countYearWeekend = 0,
        countYearPublic = 0,
        countYearHoliday = 0,
        countYearSandwich = 0;

    for(let iMonth = 1; iMonth <= 12; iMonth++){
      const startMonth = startOfMonth(new Date(this.state.year.value, iMonth, 0, 0, 0, 0)),
            endMonth = endOfMonth(new Date(this.state.year.value, iMonth, 0, 0, 0, 0)),
            monthDayDiff = differenceInDays(endMonth, startMonth) + 1,
            monthSkipBefore = this.day.findIndex(x => x === startMonth.toLocaleString('default', { weekday: 'long' }));

      let listDay = [],
          listSkipBefore = [],
          listSkipAfter = [],
          listSkipAfterInline = [],
          monthSkipAfter = 0,
          countWeekend = 0,
          countPublic = 0,
          countHoliday = 0,
          countSandwich = 0,
          countLong = 0;

      for(let iDay = 1; iDay <= monthDayDiff; iDay++){
        const dayTimestamp = new Date(this.state.year.value, iMonth - 1, iDay),
              findHoliday = this.state.nextYear ? resultApi.data.find(x => x.holiday_date === format(dayTimestamp, 'yyyy-MM-d')) : resultApi.data.find(x => x.tanggal === format(dayTimestamp, 'yyyy-MM-d')),
              name = dayTimestamp.toLocaleString('default', { weekday: 'long' });
              
        let weekend = false,
            holiday = '',
            today = false;
            
        if(typeof findHoliday !== 'undefined' && (this.state.nextYear ? findHoliday.is_national_holiday : this.state.joint ? true : !findHoliday.is_cuti)){
          if(this.state.nextYear){
            holiday = findHoliday.holiday_name;
          }else{
            holiday = findHoliday.keterangan;
          }
          
          countPublic++;
        }

        if(name === 'Sunday' || (this.state.saturday && name === 'Saturday')){
          weekend = true;
          countWeekend++;
        }
        
        if((typeof findHoliday !== 'undefined' && (this.state.nextYear ? findHoliday.is_national_holiday : this.state.joint ? true : !findHoliday.is_cuti)) || name === 'Sunday' || (this.state.saturday && name === 'Saturday')){
          countHoliday++;

          if(this.state.longWeekend){
            if(countSandwich === 1){
              if(listDay.length === 1){
                const getLastMonth = listMonth[listMonth.length - 1],
                      getLastMonthDay = typeof getLastMonth !== 'undefined' ? getLastMonth.day[getLastMonth.day.length - 1] : '';
    
                if(getLastMonthDay.weekend && getLastMonthDay.holiday){
                  listDay[listDay.length - 1].sandwich = true;
                  countLong++;
                  listDay[listDay.length - 1].sandwichCount = countYearSandwich + countLong;
                }
              }else{
                listDay[listDay.length - 1].sandwich = true;
                countLong++;
                listDay[listDay.length - 1].sandwichCount = countYearSandwich + countLong;
              }
            }

            if(countSandwich === 2){
              if(listDay.length === 2){
                const getLastMonth = listMonth[listMonth.length - 1],
                      getLastMonthDay = typeof getLastMonth !== 'undefined' ? getLastMonth.day[getLastMonth.day.length - 1] : '';
    
                if(getLastMonthDay.weekend && getLastMonthDay.holiday){
                  listDay[listDay.length - 1].sandwich = true;
                  listDay[listDay.length - 2].sandwich = true;
                  countLong++;
                  listDay[listDay.length - 2].sandwichCount = countYearSandwich + countLong;
                  countLong++;
                  listDay[listDay.length - 1].sandwichCount = countYearSandwich + countLong;
                }
              }else{
                listDay[listDay.length - 1].sandwich = true;
                listDay[listDay.length - 2].sandwich = true;
                countLong++;
                listDay[listDay.length - 2].sandwichCount = countYearSandwich + countLong;
                countLong++;
                listDay[listDay.length - 1].sandwichCount = countYearSandwich + countLong;
              }
            }

            countSandwich = 0;
          }
        }else{
          if(this.state.longWeekend){
            countSandwich++;
          }
        }
        
        if(this.state.longWeekend && listDay.length === 0 && (weekend || holiday)){
          const getLastMonth = listMonth[listMonth.length - 1],
                getLastMonthDayOne = typeof getLastMonth !== 'undefined' ? getLastMonth.day[getLastMonth.day.length - 1] : '',
                getLastMonthDayTwo = typeof getLastMonth !== 'undefined' ? getLastMonth.day[getLastMonth.day.length - 2] : '',
                getLastMonthDayThree = typeof getLastMonth !== 'undefined' ? getLastMonth.day[getLastMonth.day.length - 3] : '';
                
          if(typeof getLastMonth !== 'undefined' && getLastMonthDayOne && getLastMonthDayTwo){
            if(getLastMonthDayThree.weekend || getLastMonthDayThree.holiday){
              if(!getLastMonthDayTwo.weekend && !getLastMonthDayTwo.holiday && !getLastMonthDayOne.weekend && !getLastMonthDayOne.holiday){
                getLastMonthDayTwo.sandwich = true;
                getLastMonthDayTwo.sandwichCount = countYearSandwich + 1;

                getLastMonth.insight.sandwich++;
                countYearSandwich++;

                getLastMonth.insight.workingPer = ((getLastMonth.day.length - getLastMonth.insight.holiday - getLastMonth.insight.sandwich) / getLastMonth.day.length) * 100;
                getLastMonth.insight.sandwichPer = (getLastMonth.insight.sandwich / getLastMonth.day.length) * 100;
                getLastMonth.insight.holidayPer = (getLastMonth.insight.holiday / getLastMonth.day.length) * 100;
              }

              if(!getLastMonthDayOne.weekend && !getLastMonthDayOne.holiday){
                getLastMonthDayOne.sandwich = true;
                getLastMonthDayOne.sandwichCount = countYearSandwich + 1;

                getLastMonth.insight.sandwich++;
                countYearSandwich++;

                getLastMonth.insight.workingPer = ((getLastMonth.day.length - getLastMonth.insight.holiday - getLastMonth.insight.sandwich) / getLastMonth.day.length) * 100;
                getLastMonth.insight.sandwichPer = (getLastMonth.insight.sandwich / getLastMonth.day.length) * 100;
                getLastMonth.insight.holidayPer = (getLastMonth.insight.holiday / getLastMonth.day.length) * 100;
              }
            }
          }
        }
        
        if(this.today.getTime() === dayTimestamp.getTime()){
          today = true;
        }
        
        listDay.push({
          day: iDay,
          dayYear: countYear,
          daySemester: countSemester,
          dayQuarter: countQuarter,
          name: name,
          nameShort: name.substring(0, 3),
          weekend: weekend,
          weekendCount: weekend ? countYearWeekend + countWeekend : '',
          holiday: holiday,
          holidayCount: holiday ? countYearPublic + countPublic : '',
          sandwich: false,
          sandwichCount: '',
          today: today,
          timestamp: dayTimestamp
        });
        
        if(this.state.longWeekend){
          if(iMonth === 12 && iDay === 31){
            if(listDay[28].weekend || listDay[28].holiday){
              if(!listDay[29].weekend && !listDay[29].holiday){
                listDay[29].sandwich = true;
                countLong++;
                listDay[29].sandwichCount = countYearSandwich + countLong;
              }
              
              if(!listDay[30].weekend && !listDay[30].holiday){
                listDay[30].sandwich = true;
                countLong++;
                listDay[30].sandwichCount = countYearSandwich + countLong;
              }
            }

            if(listDay[29].weekend || listDay[29].holiday){
              if(!listDay[30].weekend && !listDay[30].holiday){
                listDay[30].sandwich = true;
                countLong++;
                listDay[30].sandwichCount = countYearSandwich + countLong;
              }
            }
          }
        }

        countSemester++;
        countQuarter++;
        countYear++;
      }

      for(let iSkipBefore = 0; iSkipBefore < monthSkipBefore; iSkipBefore++){
        listSkipBefore.push('');
      }

      monthSkipAfter = 7 - ((listDay.length + listSkipBefore.length) % 7);

      if(monthSkipAfter !== 7){
        for(let iSkipAfter = 0; iSkipAfter < monthSkipAfter; iSkipAfter++){
          listSkipAfter.push('');
        }
      }
      
      for(let iSkipAfterInline = 0; iSkipAfterInline < (31 - listDay.length); iSkipAfterInline++){
        listSkipAfterInline.push('');
      }
      
      if(calHigh < listDay.length){
        calHigh = listDay.length;
      }
      
      listMonth.push({
        month: iMonth,
        name: startMonth.toLocaleString('default', { month: 'long' }),
        quarter: Math.floor((startMonth.getMonth() + 3) / 3),
        semester: iMonth < 6 ? 1 : 2,
        skipBefore: listSkipBefore,
        skipAfter: listSkipAfter,
        skipAfterInline: listSkipAfterInline,
        day: listDay,
        timestamp: startMonth,
        insight: {
          public: countPublic,
          weekend: countWeekend,
          holiday: countHoliday,
          sandwich: countLong,
          workingPer: ((listDay.length - countHoliday - countLong) / listDay.length) * 100,
          sandwichPer: (countLong / listDay.length) * 100,
          holidayPer: (countHoliday / listDay.length) * 100
        }
      });

      countYearPublic = countYearPublic + countPublic;
      countYearWeekend = countYearWeekend + countWeekend;
      countYearHoliday = countYearHoliday + countHoliday;
      countYearSandwich = countYearSandwich + countLong;
      
      if(iMonth === 3 || iMonth === 6 || iMonth === 9 || iMonth === 12){
        if(iMonth === 3){
          this.quarter[0] = countQuarter - 1;
        }else if(iMonth === 6){
          this.quarter[1] = countQuarter - 1;
          this.semester[0] = countSemester - 1;

          countSemester = 1;
        }else if(iMonth === 9){
          this.quarter[2] = countQuarter - 1;
        }else if(iMonth === 12){
          this.quarter[3] = countQuarter - 1;
          this.semester[1] = countSemester - 1;

          countSemester = 1;
        }
        
        countQuarter = 1;
      }
    }
    
    this.setState({
      calendar: listMonth,
      totalDays: countYear - 1,
      totalWeekend: countYearWeekend,
      totalPublic: countYearPublic,
      totalHoliday: countYearHoliday,
      totalLong: countYearSandwich,
      high: 100 / calHigh,
      pageLoad: false
    });
  }

  toggleDay(event){
    const theDay = parseInt(event.target.dataset.day);

    let topPad = 0,
        delay = 0;

    if(this.state.dayOpen === theDay){
      this.setState({ dayOpen: '' });
      
      if(this.state.isMobile){
        if(this.state.isLandscape){
          topPad = 116;
        }else{
          topPad = 216;
        }
      }else if(this.state.isTablet){
        topPad = 116;
      }else{
        topPad = 168;
      }

      delay = 300;
    }else{
      this.setState({ dayOpen: theDay });
      
      if(this.state.inline){
        topPad = 90 + 45;
      }else{
        topPad = 90 + 60;
      }

      if(this.state.isMobile){
        if(this.state.isLandscape){
          topPad = topPad - 52;
        }else{
          topPad = topPad + 40;
        }
      }else if(this.state.isTablet){
        topPad = topPad - 52;
      }

      delay = 250;
    }
    
    setTimeout(() => {
      window.scrollTo({ top: document.getElementById('day-' + event.target.dataset.day).getBoundingClientRect().top + window.scrollY - topPad, behavior: 'smooth' });
    }, delay);
  }

  goToday(){
    this.scrollToday();
  }

  scrollToday(){
    if(this.myRef.current){
      let topPad = 0;

      if(this.state.isMobile){
        if(this.state.isLandscape){
          topPad = 118;
        }else{
          topPad = 218;
        }
      }else if(this.state.isTablet){
        topPad = 118;
      }else{
        topPad = 168;
      }

      window.scrollTo({ top: this.myRef.current.getBoundingClientRect().top + window.scrollY - topPad, behavior: 'smooth' });
    }
  }

  handleResize(){
    let landscape = true,
        table = false,
        mobile = false;

    if(window.innerWidth < window.innerHeight){
      landscape = false;
    }

    if(window.innerWidth <= 767){
      table = false;
      mobile = true;
    }else if(window.innerWidth >= 768 && window.innerWidth <= 1024){
      table = true;
      mobile = false;
    }

    this.setState({
      isMobile: mobile,
      isTablet: table,
      isLandscape: landscape
    });

    // console.log(window.innerWidth, window.innerHeight, 'isMobile: ' + mobile, 'isTablet: ' + table, 'isLandscape: ' + landscape);

    // @media screen and (min-width: 1025px) and (max-width: 1600px){}

    // @media screen and (min-width: 768px) and (max-width: 1024px){}

    // @media screen and (min-width: 768px) and (max-width: 1024px) and (orientation: landscape){}

    // @media screen and (min-width: 768px) and (max-width: 1024px) and (orientation: portrait){}

    // @media screen and (max-width: 767px){}

    // @media screen and (max-width: 767px) and (orientation: landscape){}

    // @media screen and (max-width: 767px) and (orientation: portrait){}

  }

  renderInsight(longWeekend, day, weekend, publicHol, publicWeekend, long, holiday, working){
    return(
      <ul className="insight">
        <li>
          Total Day
          <strong>{day} <span>day{day > 1 ? 's' : ''}</span></strong>
        </li>
        <li>
          Weekend
          <strong>{weekend} <span>day{weekend > 1 ? 's' : ''}</span></strong>
        </li>
        <li>
          Public Holiday
          <strong>{publicHol} <span>day{publicHol > 1 ? 's' : ''}</span> {publicWeekend ? (<><span>(</span>{publicWeekend} <span>in weekend</span><span>)</span></>) : ''}</strong>
        </li>
        <li>
          Weekday
          <strong><div className="grey"></div>{working} <span>day{working > 1 ? 's' : ''}</span></strong>
        </li>
        {/* <li>
          Public Holiday on Weekend
          <strong>{publicWeekend} <span>day{publicWeekend > 1 ? 's' : ''}</span></strong>
        </li> */}
        {longWeekend ? (
          <li>
            Long Weekend
            <strong><div className="green"></div>{long} <span>day{long > 1 ? 's' : ''}</span></strong>
          </li>
        ) : ''}
        <li>
          Total Holiday
          <strong><div className="red"></div>{holiday} <span>day{holiday > 1 ? 's' : ''}</span></strong>
        </li>
      </ul>
    );
  }

  renderMeter(inline, working, sandwich, holiday){
    return(
      <ul className={`meter ${inline ? 'inline' : ''}`}>
        <li style={{width: working + '%'}}><span>{parseFloat((working).toFixed(2))}%</span></li>
        <li style={{width: sandwich + '%' }}>{sandwich ? (<span>{parseFloat((sandwich).toFixed(2))}%</span>) : ''}</li>
        <li style={{width: holiday + '%' }}><span>{parseFloat((holiday).toFixed(2))}%</span></li>
      </ul>
    );
  }

  render(){
    return(
      <>
        <Helmet>
          <title>Holiday</title>
        </Helmet>

        <header>
          <ul className={this.state.nextYear ? 'more' : ''}>
            <li>
              <a href="/">
                <Logo />
              </a>
              <div className="today" onClick={this.goToday}>
                <span>Today </span><strong>{this.today.toLocaleString('default', { weekday: 'long' })}, {format(this.today, 'd MMMM yyyy')}</strong>
              </div>
            </li>
            <li>
              <label>Month</label>
              <Select
                className="react-select"
                classNamePrefix="react-select"
                name="month"
                value={this.state.month}
                options={this.month}
                onChange={this.selectChange}
                menuPortalTarget={document.querySelector('body')}
              />
            </li>
            <li>
              <label>Year</label>
              <Select
                className="react-select"
                classNamePrefix="react-select"
                name="year"
                value={this.state.year}
                options={this.state.yearList}
                onChange={this.selectChange}
                menuPortalTarget={document.querySelector('body')}
              />
            </li>
            {this.state.nextYear ? '' : (
              <li>
                <button type="button" onClick={this.switchJoint}>
                  <span>Joint leave?</span>
                  {this.state.joint ? (<><RiEyeFill />Show</>) : (<><RiEyeOffFill />Hide</>)}
                </button>
              </li>
            )}
            <li>
              <button type="button" onClick={this.switchSaturday}>
                <span>Saturday is weekend?</span>
                {this.state.saturday ? (<><RiCheckboxCircleFill />Yes</>) : (<><RiCloseCircleFill />No</>)}
              </button>
            </li>
            <li>
              <button type="button" onClick={this.switchLongWeekend}>
                <span>Long weekend?</span>
                {this.state.longWeekend ? (<><RiEyeFill />Show</>) : (<><RiEyeOffFill />Hide</>)}
              </button>
            </li>
            <li>
              <button type="button" onClick={this.switchInline}>
                <span>View</span>
                {this.state.inline ? (<><RiCalendarTodoFill />List</>) : (<><RiCalendarEventFill />Calendar</>)}
              </button>
            </li>
          </ul>
        </header>

        <div className="pad-top"></div>

        {this.state.pageLoad ? (
          <div className="loading">
            <ul>
              <li><div></div></li>
              <li><div></div></li>
              <li><div></div></li>
              <li><div></div></li>
              <li><div></div></li>
              <li><div></div></li>
              <li><div></div></li>
              <li><div></div></li>
              <li><div></div></li>
            </ul>
            Loading...
          </div>
        ) : (
          <ul className="calendar">
            <li className="year">
              <div>{this.state.year.label}</div>
              {this.renderInsight(this.state.longWeekend, this.state.totalDays, this.state.totalWeekend, this.state.totalPublic, (this.state.totalWeekend + this.state.totalPublic) - this.state.totalHoliday, this.state.totalLong, this.state.totalHoliday, this.state.totalDays - this.state.totalHoliday - this.state.totalLong)}
              {this.renderMeter(this.state.inline, ((this.state.totalDays - this.state.totalHoliday - this.state.totalLong) / this.state.totalDays) * 100, (this.state.totalLong / this.state.totalDays) * 100, (this.state.totalHoliday / this.state.totalDays) * 100)}
            </li>
            {this.state.calendar.map((valMonth, indMonth) => (
              <li key={valMonth.month} id={valMonth.name}>
                <StickyContainer>
                <Sticky
                  topOffset={this.state.isTablet ? -120 : -70}
                  bottomOffset={this.state.isTablet ? -120 : -70}
                >
                    {({
                      // style,
                      isSticky,
                      // wasSticky,
                      // distanceFromTop,
                      // distanceFromBottom,
                      // calculatedHeight
                    }) => (
                      // <div className={`head ${isSticky ? 'sticky' : ''} ${(this.state.inline ? distanceFromBottom > (this.state.isTablet ? -32 : -16) : distanceFromBottom > (this.state.isTablet ? -100 : -31)) && distanceFromBottom < (this.state.isTablet ? 120 : 70) ? 'was-sticky' : ''}`}>
                      <div className={`head ${isSticky ? 'sticky' : ''}`}>
                      {/* <div className={`head ${isSticky ? 'sticky' : ''} ${distanceFromBottom}`}> */}
                        {isSticky && this.state.monthActive.label !== valMonth.name ? (
                          <input style={{display: 'none'}} onChange={this.monthChange(valMonth.name)} />
                        ) : ''}
                        
                        <div className="name">{valMonth.name} {this.state.year.label}</div>

                        {this.renderInsight(this.state.longWeekend, valMonth.day.length, valMonth.insight.weekend, valMonth.insight.public, (valMonth.insight.weekend + valMonth.insight.public) - valMonth.insight.holiday, valMonth.insight.sandwich, valMonth.insight.holiday, valMonth.day.length - valMonth.insight.holiday - valMonth.insight.sandwich)}
                        {this.renderMeter(this.state.inline, valMonth.insight.workingPer, valMonth.insight.sandwichPer, valMonth.insight.holidayPer)}
                      </div>
                    )}
                  </Sticky>
                  
                  <ul className={`day ${this.state.inline ? 'inline' : ''}`}>
                    {!this.state.inline && valMonth.skipBefore.map((valSkip, indSkip) => (
                      <li key={`skipBefore-${valMonth.month}-${indSkip}`}><div></div></li>
                    ))}

                    {valMonth.day.map((valDay, indDay) => (
                      // <li key={`${valMonth.month}-${valDay.day}`} className={`${valDay.holiday ? 'holiday' : ''} ${valDay.weekend ? 'weekend' : ''} ${valDay.sandwich ? 'sandwich' : ''} ${this.state.dayOpen === valDay.dayYear ? 'big' : ''}`} id={valDay.today ? 'today' : ''} ref={valDay.today ? this.myRef : ''} style={{width: this.state.inline ? this.state.high + '%' : ''}}></li>
                      <li key={`${valMonth.month}-${valDay.day}`} className={`${valDay.today ? 'today' : ''} ${valDay.holiday ? 'holiday' : ''} ${valDay.weekend ? 'weekend' : ''} ${valDay.sandwich ? 'sandwich' : ''} ${this.state.dayOpen === valDay.dayYear ? 'big' : ''}`} id={`day-${valDay.dayYear}`} ref={valDay.today ? this.myRef : ''} style={{width: this.state.inline ? this.state.high + '%' : ''}}>
                        <div>
                          <div onClick={this.toggleDay} data-day={valDay.dayYear}>
                              {valDay.holiday && valDay.weekend ? (<span></span>) : ''}
                              <ul>
                                {/* {console.log(this.state.dayOpen, valDay.dayYear)} */}
                                <li>{valDay.day}</li>
                                <li>{this.state.dayOpen === valDay.dayYear ? valDay.name : this.state.inline ? valDay.nameShort : window.innerWidth >= 845 ? valDay.name : valDay.nameShort}</li>
                                {(valDay.holiday || valDay.weekend || valDay.sandwich) ? (
                                  <li>
                                    {valDay.holiday ? valDay.weekend ? 'Weekend & ' + valDay.holiday : valDay.holiday : valDay.weekend ? 'Weekend' : '' || (valDay.sandwich ? 'Long Weekend' : '')}
                                    {valDay.weekendCount ? (<span>Weekend <strong>{valDay.weekendCount}</strong> in year</span>) : ''}
                                    {valDay.holidayCount ? (<span>Public Holiday <strong>{valDay.holidayCount}</strong> in year</span>) : ''}
                                    {valDay.sandwichCount ? (<span>Long Weekend <strong>{valDay.sandwichCount}</strong> in year</span>) : ''}
                                  </li>
                                ) : ''}
                              </ul>
                              <div className="quarter">
                                Q<strong>{valMonth.quarter}</strong>/S<strong>{valMonth.semester}</strong>
                                {/* / <strong>{valMonth.quarter === 1 ? 'First' : valMonth.quarter === 2 ? 'Second' : valMonth.quarter === 3 ? 'Third' : valMonth.quarter === 4 ? 'Fourth' : ''}</strong> Quarter */}
                              </div>
                              <div className="value">
                                <ul>
                                  <li>Day <strong>{valDay.dayQuarter}</strong> in quarter</li>
                                  <li>Day <strong>{valDay.daySemester}</strong> in semester</li>
                                  <li>Day <strong>{valDay.dayYear}</strong> in year</li>
                                </ul>
                              </div>
                              <div className="percent">
                                <ul>
                                  <li>{parseFloat(((valDay.dayQuarter / this.quarter[valMonth.quarter - 1]) * 100).toFixed(2))}%</li>
                                  <li>{parseFloat(((valDay.daySemester / this.semester[valMonth.semester - 1]) * 100).toFixed(2))}%</li>
                                  <li>{parseFloat(((valDay.dayYear / this.state.totalDays) * 100).toFixed(2))}%</li>
                                </ul>
                              </div>
                          </div>
                        </div>
                      </li>
                    ))}
                    
                    {!this.state.inline ? valMonth.skipAfter.map((valSkip, indSkip) => (
                      <li key={`skipAfter-${valMonth.month}-${indSkip}`}><div></div></li>
                    )) : valMonth.skipAfterInline.map((valSkip, indSkip) => (
                      <li key={`skipAfter-${valMonth.month}-${indSkip}`} style={{width: this.state.inline ? this.state.high + '%' : ''}}><div></div></li>
                    ))}
                  </ul>
                </StickyContainer>
              </li>
            ))}
          </ul>
        )}

        <footer>
          {/* Copyrights &copy; {this.today.getFullYear() !== this.copy ? this.copy + ' - ' + this.today.getFullYear() : this.copy} <a href="/">Holiday</a> by <a href="https://nabilamerthabit.com" target="_blank" rel="noreferrer">Nabil Amer Thabit</a>. All Rights Reserved. */}
          <a href="/">Holiday</a> &copy; {this.today.getFullYear() !== this.copy ? this.copy + ' - ' + this.today.getFullYear() : this.copy} by <a href="https://nabilamerthabit.com" target="_blank" rel="noreferrer">Nabil Amer Thabit</a> is licensed under <a href="https://creativecommons.org/licenses/by-nc-sa/4.0/?ref=chooser-v1" target="_blank" rel="license noopener noreferrer">CreativeCommons BY-NC-SA 4.0 <RiCreativeCommonsLine /> <RiCreativeCommonsByLine /> <RiCreativeCommonsNcLine /> <RiCreativeCommonsSaLine /></a>
          <div>Holiday data from <a target="_blank" rel="noreferrer" href="https://dayoffapi.vercel.app/">dayoff-API</a> for current with previous year data and <a target="_blank" rel="noreferrer" href="https://api-harilibur.vercel.app/">API Hari Libur</a> for next year data. We do not guarantee the accuracy or completeness of the information provided.</div>
        </footer>
      </>
    );
  }
}

export default App;